import { useState } from "react";
// import fetchData from "../../axios/fetchData";
// import { login } from "../../axios/serverUrl";
// import { toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import { jwtDecode } from "jwt-decode";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import Logo from "../../assets/images/logo.png";
import CustomLoader from "../../component/Loader/Loader";
import { setLogout } from "../../redux/actions/coilAction";
import SubHeader from "../SubHeader/SubHeader";
import {userLoggedOut} from "../../analytics/analytics";
const appVersion = process.env.REACT_APP_VERSION;

const CustomHeader = ({ handleSidebar }) => {
  const navigator = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const userDetail = JSON.parse(localStorage.getItem("userDetail"));

  const location = useLocation();
  const isSnapshotRoute = true;

  const handleLogout = async () => {
    localStorage.clear();
    userLoggedOut();
    navigator("/");
  };
  const changeNavigation = (activeTab) => {
    const navigationIndices = {profile: 0, customers: 1, buildings: 2, smartcoil: 3, tenantAdmins: 4, usersAll: 5};
    const index = navigationIndices[activeTab] ?? 0
    navigator("/admin?tab=" + index);
  };
  return (
    <div className="d-flex justify-content-space-between align-items-center custom-header-wrapper">
      <div className="header_content">
        <div className="layout-topbar customerheader-layout-topbar justify-content-start pe-5">
          {!location.pathname.includes("home") &&
            !location.pathname.includes("admin") && (
              <button
                style={{ cursor: "pointer" }}
                className="d-lg-none d-block border-none"
                onClick={handleSidebar}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  width="22"
                  height="22"
                  x="0"
                  y="0"
                  viewBox="0 0 384 384"
                >
                  <g>
                    <path
                      d="M368 154.668H16c-8.832 0-16-7.168-16-16s7.168-16 16-16h352c8.832 0 16 7.168 16 16s-7.168 16-16 16zM368 32H16C7.168 32 0 24.832 0 16S7.168 0 16 0h352c8.832 0 16 7.168 16 16s-7.168 16-16 16zM368 277.332H16c-8.832 0-16-7.168-16-16s7.168-16 16-16h352c8.832 0 16 7.168 16 16s-7.168 16-16 16zm0 0"
                      fill="#000000"
                      opacity="1"
                      data-original="#000000"
                      className=""
                    ></path>
                  </g>
                </svg>
              </button>
            )}
          <div className="d-flex w-100">
            <Link
              className="layout-topbar-logo me-3"
              style={{
                cursor: "pointer",
                marginLeft: userDetail?.authority === "TENANT_ADMIN" ? "" : "",
              }}
              to="/home"
            >
              <img src={Logo} alt="logo" />
            </Link>
            <div className="d-none d-lg-flex ms-5 ps-3">
              <SubHeader />
            </div>
          </div>
        </div>
      </div>
      <div className="header_account">
        <div className="pr-1 pr-md-5">
          <Dropdown className="select-icon">
            <Dropdown.Toggle id="dropdown-basic">
              <div className="circle-highlight mr-2">
                {userDetail?.firstName != null && userDetail?.firstName[0]}
              </div>
              <span className="ml-1">{userDetail?.firstName}</span>
            </Dropdown.Toggle>

            {userDetail?.authority !== "TENANT_ADMIN" ? (
              <Dropdown.Menu style={{ minWidth: "200px" }}>
                <div className="divide mx-2"></div>
                <Dropdown.Item className="my-1">
                  <span
                    onClick={() => {
                      navigator("/home");
                    }}
                    className="dropdown-menu-text"
                  >
                    Home
                  </span>
                </Dropdown.Item>
                <div className="divide mx-2"></div>
                {/* <Dropdown.Item href="#/action-1">
                {userDetail?.firstName + " " + userDetail?.lastName}
              </Dropdown.Item> */}
                <Dropdown.Item className="mt-1">
                  <span className="dropdown-menu-text">
                    {userDetail?.authority === "SYS_ADMIN" ? "Admin" : ""}{" "}
                    Console
                  </span>
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    changeNavigation("profile");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 13 13"
                    fill="none"
                    className="me-3"
                  >
                    <path
                      d="M6.50049 6.49951C7.14315 6.49932 7.77132 6.30859 8.30559 5.95142C8.83986 5.59426 9.25624 5.08671 9.50208 4.49294C9.74793 3.89916 9.8122 3.24582 9.68678 2.61552C9.56135 1.98522 9.25186 1.40626 8.79744 0.951833C8.34301 0.497405 7.76405 0.187916 7.13375 0.0624921C6.50345 -0.0629315 5.85011 0.00134251 5.25633 0.247188C4.66256 0.493033 4.15501 0.909411 3.79784 1.44368C3.44068 1.97795 3.24995 2.60612 3.24976 3.24878C3.2495 3.67575 3.33341 4.09857 3.49668 4.49309C3.65996 4.8876 3.89939 5.24606 4.2013 5.54797C4.50321 5.84988 4.86167 6.08931 5.25618 6.25259C5.6507 6.41586 6.07352 6.49977 6.50049 6.49951ZM6.50049 8.12488C4.33106 8.1239 0 9.21301 0 11.3746V13H13V11.3746C13 9.21301 8.66992 8.12488 6.50049 8.12488Z"
                      fill="#707C82"
                    />
                  </svg>
                  Profile
                </Dropdown.Item>
                <div className="divide mx-2 mt-2"></div>
                <div className="d-block d-lg-none">
                  <Dropdown.Item className="mt-1">
                    <span className="dropdown-menu-text">Dashboards</span>
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      navigator("/customer/snapshot");
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      className="me-3"
                    >
                      <path
                        d="M1.33333 12C0.966667 12 0.652778 11.8694 0.391667 11.6083C0.130556 11.3472 0 11.0333 0 10.6667V1.33333C0 0.966667 0.130556 0.652778 0.391667 0.391667C0.652778 0.130556 0.966667 0 1.33333 0H10.6667C11.0333 0 11.3472 0.130556 11.6083 0.391667C11.8694 0.652778 12 0.966667 12 1.33333V10.6667C12 11.0333 11.8694 11.3472 11.6083 11.6083C11.3472 11.8694 11.0333 12 10.6667 12H1.33333ZM4.66667 10.6667V6.66667H1.33333V10.6667H4.66667ZM6 10.6667H10.6667V6.66667H6V10.6667ZM1.33333 5.33333H10.6667V1.33333H1.33333V5.33333Z"
                        fill="#707C82"
                      />
                    </svg>
                    Snapshot
                  </Dropdown.Item>
                  {!isSnapshotRoute && (
                    <Dropdown.Item onClick={() => {}}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="13"
                        height="15"
                        viewBox="0 0 13 15"
                        fill="none"
                        className="me-3"
                      >
                        <path
                          d="M5.4963 11.6267L3.04198 9.10222L4.04444 8.07111L5.4963 9.56444L8.4 6.57778L9.40247 7.60889L5.4963 11.6267ZM1.38272 14.2222C1.00247 14.2222 0.676955 14.083 0.406173 13.8044C0.135391 13.5259 0 13.1911 0 12.8V2.84444C0 2.45333 0.135391 2.11852 0.406173 1.84C0.676955 1.56148 1.00247 1.42222 1.38272 1.42222H2.07407V0H3.45679V1.42222H8.98765V0H10.3704V1.42222H11.0617C11.442 1.42222 11.7675 1.56148 12.0383 1.84C12.3091 2.11852 12.4444 2.45333 12.4444 2.84444V12.8C12.4444 13.1911 12.3091 13.5259 12.0383 13.8044C11.7675 14.083 11.442 14.2222 11.0617 14.2222H1.38272ZM1.38272 12.8H11.0617V5.68889H1.38272V12.8ZM1.38272 4.26667H11.0617V2.84444H1.38272V4.26667Z"
                          fill="#707C82"
                        />
                      </svg>
                      Events
                    </Dropdown.Item>
                  )}
                  <Dropdown.Item
                    onClick={() => {
                      navigator("/customer/fouling");
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      className="me-3"
                    >
                      <path
                        d="M9.09365 11.0831L13.7389 5.84895L14.4953 6.60529L8.99463 12.8178L6.42188 10.245L6.3335 10.1566L6.24511 10.245L2.3335 14.1566L1.51027 13.3334L6.3335 8.51019L8.91177 11.0885L9.00559 11.1823L9.09365 11.0831ZM9.09365 7.08305L13.7389 1.84895L14.4953 2.60529L8.99463 8.81777L6.42188 6.24503L6.3335 6.15664L6.24511 6.24503L2.3335 10.1566L1.51027 9.33342L6.3335 4.51019L8.91177 7.08847L9.00559 7.18228L9.09365 7.08305Z"
                        fill="#707C82"
                        stroke="#707C82"
                        strokeWidth="0.25"
                      />
                    </svg>
                    Fouling
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      navigator("/customer/performance");
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      className="me-3"
                    >
                      <path
                        d="M9 12V6.75H12V12H9ZM4.5 12V0H7.5V12H4.5ZM0 12V3.75H3V12H0Z"
                        fill="#707C82"
                      />
                    </svg>
                    Performance
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => navigator("/customer/raw-data")}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17"
                      height="17"
                      viewBox="0 0 17 17"
                      fill="none"
                      className="me-3"
                    >
                      <path
                        d="M2.8335 14.1666V12.0416H5.66683V14.1666H2.8335ZM2.8335 11.3333V8.49992H5.66683V11.3333H2.8335ZM2.8335 7.79159V2.83325H5.66683V7.79159H2.8335ZM7.0835 14.1666V9.20825H9.91683V14.1666H7.0835ZM7.0835 8.49992V5.66659H9.91683V8.49992H7.0835ZM7.0835 4.95825V2.83325H9.91683V4.95825H7.0835ZM11.3335 14.1666V12.7499H14.1668V14.1666H11.3335ZM11.3335 12.0416V9.20825H14.1668V12.0416H11.3335ZM11.3335 8.49992V2.83325H14.1668V8.49992H11.3335Z"
                        fill="#707C82"
                      />
                    </svg>
                    Raw Data
                  </Dropdown.Item>
                  {!isSnapshotRoute && (
                    <Dropdown.Item onClick={() => {}}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="13"
                        height="12"
                        viewBox="0 0 13 12"
                        fill="none"
                        className="me-3"
                      >
                        <path
                          d="M6.41743 11.0939L6.49258 11.16L6.57352 11.1011L9.5962 8.90278H12H12.125V8.77778V7.66667V7.54167H12H9.12778H9.08703L9.05411 7.56568L6.58386 9.36761L2.91608 6.12853L2.84479 6.06557L2.7651 6.11749L0.931765 7.31193L0.875 7.34892V7.41667V8.77778V9.00799L1.06808 8.88261L2.6997 7.82312L6.41743 11.0939ZM6.41592 6.09249L6.48774 6.15779L6.56879 6.10437L12.0688 2.47937L12.125 2.44232V2.375V1V0.768006L11.9312 0.895605L6.63451 4.3839L4.0327 2.01862L3.96061 1.95309L3.87945 2.00698L0.930844 3.96532L0.875 4.00241V4.06944V5.44444V5.67737L1.0691 5.54861L3.81435 3.72743L6.41592 6.09249Z"
                          fill="#707C82"
                          stroke="#707C82"
                          strokeWidth="0.25"
                        />
                      </svg>
                      Predictive
                    </Dropdown.Item>
                  )}
                </div>
                <div className="divide mx-2"></div>
                <Dropdown.Item onClick={handleLogout}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="11"
                    viewBox="0 0 14 11"
                    fill="none"
                    className="me-3"
                  >
                    <path
                      d="M13.8065 5.9866L9.13911 10.7961C9.0456 10.8917 8.92677 10.9566 8.79757 10.9828C8.66838 11.0089 8.53456 10.9951 8.41296 10.9431C8.29135 10.891 8.18737 10.8031 8.11409 10.6903C8.04081 10.5775 8.00149 10.4449 8.00108 10.3092V7.56191H4.22281C4.13524 7.5621 4.04849 7.54446 3.96755 7.50999C3.8866 7.47553 3.81306 7.42491 3.75113 7.36106C3.68921 7.29722 3.64013 7.22139 3.6067 7.13793C3.57327 7.05447 3.55616 6.96502 3.55635 6.87472V4.12234C3.55616 4.03205 3.57327 3.9426 3.6067 3.85914C3.64013 3.77568 3.68921 3.69985 3.75113 3.636C3.81306 3.57215 3.8866 3.52154 3.96755 3.48708C4.04849 3.45261 4.13524 3.43497 4.22281 3.43516H8.00108V0.687912C8.00149 0.552156 8.04081 0.419554 8.11409 0.306769C8.18737 0.193983 8.29135 0.10605 8.41296 0.0540139C8.53456 0.00197785 8.66838 -0.0118388 8.79757 0.0143043C8.92677 0.0404474 9.0456 0.10538 9.13911 0.200945L13.8058 5.01267C13.9301 5.14229 13.9999 5.31719 14 5.49949C14.0001 5.68178 13.9306 5.85679 13.8065 5.9866ZM5.33453 10.6553V9.50977C5.33434 9.41861 5.29913 9.33123 5.23661 9.26677C5.1741 9.20231 5.08936 9.16601 5.00094 9.16581H2.66655C2.54974 9.166 2.43405 9.14243 2.32609 9.09642C2.21814 9.05042 2.12005 8.98291 2.03745 8.89774C1.95486 8.81258 1.88938 8.71144 1.84476 8.60013C1.80015 8.48882 1.77728 8.36952 1.77746 8.24908V2.74872C1.77728 2.62827 1.80015 2.50898 1.84476 2.39767C1.88938 2.28636 1.95486 2.18523 2.03745 2.10006C2.12005 2.0149 2.21814 1.94738 2.32609 1.90138C2.43405 1.85538 2.54974 1.83179 2.66655 1.83199H5.00023C5.08852 1.83199 5.17323 1.79598 5.23586 1.73181C5.29849 1.66764 5.33396 1.58054 5.33453 1.4895V0.343955C5.33434 0.252791 5.29913 0.165421 5.23661 0.100958C5.1741 0.0364958 5.08936 0.000193759 5.00094 0H2.66655C1.95927 0.000194471 1.28103 0.290033 0.780972 0.805771C0.280917 1.32151 -2.51477e-08 2.02091 0 2.75018L0 8.25055C0.00018855 8.97969 0.281189 9.67892 0.781223 10.1945C1.28126 10.7101 1.9594 10.9998 2.66655 11H5.00023C5.08889 11 5.17392 10.9637 5.23661 10.899C5.29931 10.8344 5.33453 10.7467 5.33453 10.6553Z"
                      fill="#707C82"
                    />
                  </svg>
                  Log out
                </Dropdown.Item>

                <div className="dropdown-menu-version-box">{`SmartCoil Dashboard v${appVersion}`}</div>
              </Dropdown.Menu>
            ) : (
              <Dropdown.Menu>
                <div className="divide mx-2"></div>
                <Dropdown.Item className="my-1">
                  <span
                    onClick={() => {
                      navigator("/home");
                    }}
                    className="dropdown-menu-text"
                  >
                    Home
                  </span>
                </Dropdown.Item>
                <div className="divide mx-2"></div>
                <Dropdown.Item className="mt-1">
                  <span className="dropdown-menu-text">Admin Console</span>
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    changeNavigation("profile");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 13 13"
                    fill="none"
                    className="me-3"
                  >
                    <path
                      d="M6.50049 6.49951C7.14315 6.49932 7.77132 6.30859 8.30559 5.95142C8.83986 5.59426 9.25624 5.08671 9.50208 4.49294C9.74793 3.89916 9.8122 3.24582 9.68678 2.61552C9.56135 1.98522 9.25186 1.40626 8.79744 0.951833C8.34301 0.497405 7.76405 0.187916 7.13375 0.0624921C6.50345 -0.0629315 5.85011 0.00134251 5.25633 0.247188C4.66256 0.493033 4.15501 0.909411 3.79784 1.44368C3.44068 1.97795 3.24995 2.60612 3.24976 3.24878C3.2495 3.67575 3.33341 4.09857 3.49668 4.49309C3.65996 4.8876 3.89939 5.24606 4.2013 5.54797C4.50321 5.84988 4.86167 6.08931 5.25618 6.25259C5.6507 6.41586 6.07352 6.49977 6.50049 6.49951ZM6.50049 8.12488C4.33106 8.1239 0 9.21301 0 11.3746V13H13V11.3746C13 9.21301 8.66992 8.12488 6.50049 8.12488Z"
                      fill="#707C82"
                    />
                  </svg>
                  Profile
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    changeNavigation("customers");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    className="me-3"
                  >
                    <path
                      d="M14.6818 11.2272V8.63627H12.0909V6.909H14.6818V4.31809H16.4091V6.909H19V8.63627H16.4091V11.2272H14.6818ZM6.90909 9.49991C5.95909 9.49991 5.14583 9.16165 4.46932 8.48514C3.7928 7.80862 3.45455 6.99537 3.45455 6.04537C3.45455 5.09537 3.7928 4.28211 4.46932 3.60559C5.14583 2.92908 5.95909 2.59082 6.90909 2.59082C7.85909 2.59082 8.67235 2.92908 9.34886 3.60559C10.0254 4.28211 10.3636 5.09537 10.3636 6.04537C10.3636 6.99537 10.0254 7.80862 9.34886 8.48514C8.67235 9.16165 7.85909 9.49991 6.90909 9.49991ZM0 16.409V13.9908C0 13.5014 0.125947 13.0516 0.377841 12.6414C0.629735 12.2312 0.964394 11.9181 1.38182 11.7022C2.27424 11.256 3.18106 10.9213 4.10227 10.6982C5.02348 10.4751 5.95909 10.3635 6.90909 10.3635C7.85909 10.3635 8.7947 10.4751 9.71591 10.6982C10.6371 10.9213 11.5439 11.256 12.4364 11.7022C12.8538 11.9181 13.1884 12.2312 13.4403 12.6414C13.6922 13.0516 13.8182 13.5014 13.8182 13.9908V16.409H0ZM1.72727 14.6817H12.0909V13.9908C12.0909 13.8325 12.0513 13.6885 11.9722 13.559C11.893 13.4295 11.7886 13.3287 11.6591 13.2567C10.8818 12.8681 10.0973 12.5766 9.30568 12.3823C8.51402 12.188 7.71515 12.0908 6.90909 12.0908C6.10303 12.0908 5.30417 12.188 4.5125 12.3823C3.72083 12.5766 2.93636 12.8681 2.15909 13.2567C2.02955 13.3287 1.92519 13.4295 1.84602 13.559C1.76686 13.6885 1.72727 13.8325 1.72727 13.9908V14.6817ZM6.90909 7.77264C7.38409 7.77264 7.79072 7.60351 8.12898 7.26525C8.46723 6.92699 8.63636 6.52037 8.63636 6.04537C8.63636 5.57037 8.46723 5.16374 8.12898 4.82548C7.79072 4.48722 7.38409 4.31809 6.90909 4.31809C6.43409 4.31809 6.02746 4.48722 5.6892 4.82548C5.35095 5.16374 5.18182 5.57037 5.18182 6.04537C5.18182 6.52037 5.35095 6.92699 5.6892 7.26525C6.02746 7.60351 6.43409 7.77264 6.90909 7.77264Z"
                      fill="#707C82"
                    />
                  </svg>
                  Customers
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    changeNavigation("buildings");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    className="me-3"
                  >
                    <path
                      d="M2.5 17.5001V5.83341H7.5V4.16675L10 1.66675L12.5 4.16675V9.16675H17.5V17.5001H2.5ZM4.16667 15.8334H5.83333V14.1667H4.16667V15.8334ZM4.16667 12.5001H5.83333V10.8334H4.16667V12.5001ZM4.16667 9.16675H5.83333V7.50008H4.16667V9.16675ZM9.16667 15.8334H10.8333V14.1667H9.16667V15.8334ZM9.16667 12.5001H10.8333V10.8334H9.16667V12.5001ZM9.16667 9.16675H10.8333V7.50008H9.16667V9.16675ZM9.16667 5.83341H10.8333V4.16675H9.16667V5.83341ZM14.1667 15.8334H15.8333V14.1667H14.1667V15.8334ZM14.1667 12.5001H15.8333V10.8334H14.1667V12.5001Z"
                      fill="#707C82"
                    />
                  </svg>
                  Buildings
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    changeNavigation("smartcoil");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="12"
                    viewBox="0 0 15 12"
                    fill="none"
                    className="me-3"
                  >
                    <g clipPath="url(#clip0_228_2813)">
                      <path
                        d="M13.22 0H1.70966L0 1.80842V10.2502L1.70966 12.0073H13.22L15 10.2502V1.80842L13.22 0Z"
                        fill="#707C82"
                      />
                      <path
                        d="M12.3969 4.43677H6.90911C6.62546 4.43677 6.39551 4.67442 6.39551 4.96758C6.39551 5.26074 6.62546 5.49839 6.90911 5.49839H12.3969C12.6806 5.49839 12.9105 5.26074 12.9105 4.96758C12.9105 4.67442 12.6806 4.43677 12.3969 4.43677Z"
                        fill="white"
                      />
                      <path
                        d="M9.28011 6.33301C9.35047 6.5014 9.39268 6.68444 9.39268 6.8748C9.39268 7.62892 8.80169 8.24393 8.07701 8.24393H4.22852C4.2848 8.88822 4.7984 9.39341 5.43161 9.39341H9.44897C10.1174 9.39341 10.6591 8.82965 10.6591 8.13411V6.33301H9.28011Z"
                        fill="white"
                      />
                      <path
                        d="M5.59334 5.50572C5.52299 5.33732 5.48077 5.15428 5.48077 4.96392C5.48077 4.2098 6.07177 3.59479 6.79644 3.59479H10.6449C10.5887 2.9505 10.0751 2.44531 9.44184 2.44531H5.42449C4.7561 2.44531 4.21436 3.00907 4.21436 3.70462V5.50572H5.59334Z"
                        fill="white"
                      />
                      <path
                        d="M7.9643 6.34033H2.47649C2.19284 6.34033 1.96289 6.57798 1.96289 6.87114C1.96289 7.1643 2.19284 7.40195 2.47649 7.40195H7.9643C8.24795 7.40195 8.4779 7.1643 8.4779 6.87114C8.4779 6.57798 8.24795 6.34033 7.9643 6.34033Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_228_2813">
                        <rect width="15" height="12" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  SmartCoil Gateways
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    changeNavigation("tenantAdmins");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    className="me-3"
                  >
                    <path
                      d="M14.6818 11.2272V8.63627H12.0909V6.909H14.6818V4.31809H16.4091V6.909H19V8.63627H16.4091V11.2272H14.6818ZM6.90909 9.49991C5.95909 9.49991 5.14583 9.16165 4.46932 8.48514C3.7928 7.80862 3.45455 6.99537 3.45455 6.04537C3.45455 5.09537 3.7928 4.28211 4.46932 3.60559C5.14583 2.92908 5.95909 2.59082 6.90909 2.59082C7.85909 2.59082 8.67235 2.92908 9.34886 3.60559C10.0254 4.28211 10.3636 5.09537 10.3636 6.04537C10.3636 6.99537 10.0254 7.80862 9.34886 8.48514C8.67235 9.16165 7.85909 9.49991 6.90909 9.49991ZM0 16.409V13.9908C0 13.5014 0.125947 13.0516 0.377841 12.6414C0.629735 12.2312 0.964394 11.9181 1.38182 11.7022C2.27424 11.256 3.18106 10.9213 4.10227 10.6982C5.02348 10.4751 5.95909 10.3635 6.90909 10.3635C7.85909 10.3635 8.7947 10.4751 9.71591 10.6982C10.6371 10.9213 11.5439 11.256 12.4364 11.7022C12.8538 11.9181 13.1884 12.2312 13.4403 12.6414C13.6922 13.0516 13.8182 13.5014 13.8182 13.9908V16.409H0ZM1.72727 14.6817H12.0909V13.9908C12.0909 13.8325 12.0513 13.6885 11.9722 13.559C11.893 13.4295 11.7886 13.3287 11.6591 13.2567C10.8818 12.8681 10.0973 12.5766 9.30568 12.3823C8.51402 12.188 7.71515 12.0908 6.90909 12.0908C6.10303 12.0908 5.30417 12.188 4.5125 12.3823C3.72083 12.5766 2.93636 12.8681 2.15909 13.2567C2.02955 13.3287 1.92519 13.4295 1.84602 13.559C1.76686 13.6885 1.72727 13.8325 1.72727 13.9908V14.6817ZM6.90909 7.77264C7.38409 7.77264 7.79072 7.60351 8.12898 7.26525C8.46723 6.92699 8.63636 6.52037 8.63636 6.04537C8.63636 5.57037 8.46723 5.16374 8.12898 4.82548C7.79072 4.48722 7.38409 4.31809 6.90909 4.31809C6.43409 4.31809 6.02746 4.48722 5.6892 4.82548C5.35095 5.16374 5.18182 5.57037 5.18182 6.04537C5.18182 6.52037 5.35095 6.92699 5.6892 7.26525C6.02746 7.60351 6.43409 7.77264 6.90909 7.77264Z"
                      fill="#707C82"
                    />
                  </svg>
                  Tenant Admins
                </Dropdown.Item>
                  <Dropdown.Item
                      onClick={() => {
                          changeNavigation("usersAll");
                      }}
                      className="mb-2"
                  >
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="19"
                          height="19"
                          viewBox="0 0 19 19"
                          fill="none"
                          className="me-3"
                      >
                          <path
                              d="M14.6818 11.2272V8.63627H12.0909V6.909H14.6818V4.31809H16.4091V6.909H19V8.63627H16.4091V11.2272H14.6818ZM6.90909 9.49991C5.95909 9.49991 5.14583 9.16165 4.46932 8.48514C3.7928 7.80862 3.45455 6.99537 3.45455 6.04537C3.45455 5.09537 3.7928 4.28211 4.46932 3.60559C5.14583 2.92908 5.95909 2.59082 6.90909 2.59082C7.85909 2.59082 8.67235 2.92908 9.34886 3.60559C10.0254 4.28211 10.3636 5.09537 10.3636 6.04537C10.3636 6.99537 10.0254 7.80862 9.34886 8.48514C8.67235 9.16165 7.85909 9.49991 6.90909 9.49991ZM0 16.409V13.9908C0 13.5014 0.125947 13.0516 0.377841 12.6414C0.629735 12.2312 0.964394 11.9181 1.38182 11.7022C2.27424 11.256 3.18106 10.9213 4.10227 10.6982C5.02348 10.4751 5.95909 10.3635 6.90909 10.3635C7.85909 10.3635 8.7947 10.4751 9.71591 10.6982C10.6371 10.9213 11.5439 11.256 12.4364 11.7022C12.8538 11.9181 13.1884 12.2312 13.4403 12.6414C13.6922 13.0516 13.8182 13.5014 13.8182 13.9908V16.409H0ZM1.72727 14.6817H12.0909V13.9908C12.0909 13.8325 12.0513 13.6885 11.9722 13.559C11.893 13.4295 11.7886 13.3287 11.6591 13.2567C10.8818 12.8681 10.0973 12.5766 9.30568 12.3823C8.51402 12.188 7.71515 12.0908 6.90909 12.0908C6.10303 12.0908 5.30417 12.188 4.5125 12.3823C3.72083 12.5766 2.93636 12.8681 2.15909 13.2567C2.02955 13.3287 1.92519 13.4295 1.84602 13.559C1.76686 13.6885 1.72727 13.8325 1.72727 13.9908V14.6817ZM6.90909 7.77264C7.38409 7.77264 7.79072 7.60351 8.12898 7.26525C8.46723 6.92699 8.63636 6.52037 8.63636 6.04537C8.63636 5.57037 8.46723 5.16374 8.12898 4.82548C7.79072 4.48722 7.38409 4.31809 6.90909 4.31809C6.43409 4.31809 6.02746 4.48722 5.6892 4.82548C5.35095 5.16374 5.18182 5.57037 5.18182 6.04537C5.18182 6.52037 5.35095 6.92699 5.6892 7.26525C6.02746 7.60351 6.43409 7.77264 6.90909 7.77264Z"
                              fill="#707C82"
                          />
                      </svg>
                      Users
                  </Dropdown.Item>
                <div className="divide mx-2"></div>
                <div className="d-block d-lg-none">
                  <Dropdown.Item className="mt-1">
                    <span className="dropdown-menu-text">Dashboards</span>
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => navigator("/customer/snapshot")}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      className="me-3"
                    >
                      <path
                        d="M1.33333 12C0.966667 12 0.652778 11.8694 0.391667 11.6083C0.130556 11.3472 0 11.0333 0 10.6667V1.33333C0 0.966667 0.130556 0.652778 0.391667 0.391667C0.652778 0.130556 0.966667 0 1.33333 0H10.6667C11.0333 0 11.3472 0.130556 11.6083 0.391667C11.8694 0.652778 12 0.966667 12 1.33333V10.6667C12 11.0333 11.8694 11.3472 11.6083 11.6083C11.3472 11.8694 11.0333 12 10.6667 12H1.33333ZM4.66667 10.6667V6.66667H1.33333V10.6667H4.66667ZM6 10.6667H10.6667V6.66667H6V10.6667ZM1.33333 5.33333H10.6667V1.33333H1.33333V5.33333Z"
                        fill="#707C82"
                      />
                    </svg>
                    Snapshot
                  </Dropdown.Item>
                  {!isSnapshotRoute && (
                    <Dropdown.Item onClick={() => {}}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="13"
                        height="15"
                        viewBox="0 0 13 15"
                        fill="none"
                        className="me-3"
                      >
                        <path
                          d="M5.4963 11.6267L3.04198 9.10222L4.04444 8.07111L5.4963 9.56444L8.4 6.57778L9.40247 7.60889L5.4963 11.6267ZM1.38272 14.2222C1.00247 14.2222 0.676955 14.083 0.406173 13.8044C0.135391 13.5259 0 13.1911 0 12.8V2.84444C0 2.45333 0.135391 2.11852 0.406173 1.84C0.676955 1.56148 1.00247 1.42222 1.38272 1.42222H2.07407V0H3.45679V1.42222H8.98765V0H10.3704V1.42222H11.0617C11.442 1.42222 11.7675 1.56148 12.0383 1.84C12.3091 2.11852 12.4444 2.45333 12.4444 2.84444V12.8C12.4444 13.1911 12.3091 13.5259 12.0383 13.8044C11.7675 14.083 11.442 14.2222 11.0617 14.2222H1.38272ZM1.38272 12.8H11.0617V5.68889H1.38272V12.8ZM1.38272 4.26667H11.0617V2.84444H1.38272V4.26667Z"
                          fill="#707C82"
                        />
                      </svg>
                      Events
                    </Dropdown.Item>
                  )}
                  <Dropdown.Item onClick={() => navigator("/customer/fouling")}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      className="me-3"
                    >
                      <path
                        d="M9.09365 11.0831L13.7389 5.84895L14.4953 6.60529L8.99463 12.8178L6.42188 10.245L6.3335 10.1566L6.24511 10.245L2.3335 14.1566L1.51027 13.3334L6.3335 8.51019L8.91177 11.0885L9.00559 11.1823L9.09365 11.0831ZM9.09365 7.08305L13.7389 1.84895L14.4953 2.60529L8.99463 8.81777L6.42188 6.24503L6.3335 6.15664L6.24511 6.24503L2.3335 10.1566L1.51027 9.33342L6.3335 4.51019L8.91177 7.08847L9.00559 7.18228L9.09365 7.08305Z"
                        fill="#707C82"
                        stroke="#707C82"
                        strokeWidth="0.25"
                      />
                    </svg>
                    Fouling
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => navigator("/customer/performance")}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      className="me-3"
                    >
                      <path
                        d="M9 12V6.75H12V12H9ZM4.5 12V0H7.5V12H4.5ZM0 12V3.75H3V12H0Z"
                        fill="#707C82"
                      />
                    </svg>
                    Performance
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => navigator("/customer/raw-data")}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17"
                      height="17"
                      viewBox="0 0 17 17"
                      fill="none"
                      className="me-3"
                    >
                      <path
                        d="M2.8335 14.1666V12.0416H5.66683V14.1666H2.8335ZM2.8335 11.3333V8.49992H5.66683V11.3333H2.8335ZM2.8335 7.79159V2.83325H5.66683V7.79159H2.8335ZM7.0835 14.1666V9.20825H9.91683V14.1666H7.0835ZM7.0835 8.49992V5.66659H9.91683V8.49992H7.0835ZM7.0835 4.95825V2.83325H9.91683V4.95825H7.0835ZM11.3335 14.1666V12.7499H14.1668V14.1666H11.3335ZM11.3335 12.0416V9.20825H14.1668V12.0416H11.3335ZM11.3335 8.49992V2.83325H14.1668V8.49992H11.3335Z"
                        fill="#707C82"
                      />
                    </svg>
                    Raw Data
                  </Dropdown.Item>
                  {!isSnapshotRoute && (
                    <Dropdown.Item onClick={() => {}}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="13"
                        height="12"
                        viewBox="0 0 13 12"
                        fill="none"
                        className="me-3"
                      >
                        <path
                          d="M6.41743 11.0939L6.49258 11.16L6.57352 11.1011L9.5962 8.90278H12H12.125V8.77778V7.66667V7.54167H12H9.12778H9.08703L9.05411 7.56568L6.58386 9.36761L2.91608 6.12853L2.84479 6.06557L2.7651 6.11749L0.931765 7.31193L0.875 7.34892V7.41667V8.77778V9.00799L1.06808 8.88261L2.6997 7.82312L6.41743 11.0939ZM6.41592 6.09249L6.48774 6.15779L6.56879 6.10437L12.0688 2.47937L12.125 2.44232V2.375V1V0.768006L11.9312 0.895605L6.63451 4.3839L4.0327 2.01862L3.96061 1.95309L3.87945 2.00698L0.930844 3.96532L0.875 4.00241V4.06944V5.44444V5.67737L1.0691 5.54861L3.81435 3.72743L6.41592 6.09249Z"
                          fill="#707C82"
                          stroke="#707C82"
                          strokeWidth="0.25"
                        />
                      </svg>
                      Predictive
                    </Dropdown.Item>
                  )}
                </div>
                <Dropdown.Item onClick={handleLogout}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="11"
                    viewBox="0 0 14 11"
                    fill="none"
                    className="me-3"
                  >
                    <path
                      d="M13.8065 5.9866L9.13911 10.7961C9.0456 10.8917 8.92677 10.9566 8.79757 10.9828C8.66838 11.0089 8.53456 10.9951 8.41296 10.9431C8.29135 10.891 8.18737 10.8031 8.11409 10.6903C8.04081 10.5775 8.00149 10.4449 8.00108 10.3092V7.56191H4.22281C4.13524 7.5621 4.04849 7.54446 3.96755 7.50999C3.8866 7.47553 3.81306 7.42491 3.75113 7.36106C3.68921 7.29722 3.64013 7.22139 3.6067 7.13793C3.57327 7.05447 3.55616 6.96502 3.55635 6.87472V4.12234C3.55616 4.03205 3.57327 3.9426 3.6067 3.85914C3.64013 3.77568 3.68921 3.69985 3.75113 3.636C3.81306 3.57215 3.8866 3.52154 3.96755 3.48708C4.04849 3.45261 4.13524 3.43497 4.22281 3.43516H8.00108V0.687912C8.00149 0.552156 8.04081 0.419554 8.11409 0.306769C8.18737 0.193983 8.29135 0.10605 8.41296 0.0540139C8.53456 0.00197785 8.66838 -0.0118388 8.79757 0.0143043C8.92677 0.0404474 9.0456 0.10538 9.13911 0.200945L13.8058 5.01267C13.9301 5.14229 13.9999 5.31719 14 5.49949C14.0001 5.68178 13.9306 5.85679 13.8065 5.9866ZM5.33453 10.6553V9.50977C5.33434 9.41861 5.29913 9.33123 5.23661 9.26677C5.1741 9.20231 5.08936 9.16601 5.00094 9.16581H2.66655C2.54974 9.166 2.43405 9.14243 2.32609 9.09642C2.21814 9.05042 2.12005 8.98291 2.03745 8.89774C1.95486 8.81258 1.88938 8.71144 1.84476 8.60013C1.80015 8.48882 1.77728 8.36952 1.77746 8.24908V2.74872C1.77728 2.62827 1.80015 2.50898 1.84476 2.39767C1.88938 2.28636 1.95486 2.18523 2.03745 2.10006C2.12005 2.0149 2.21814 1.94738 2.32609 1.90138C2.43405 1.85538 2.54974 1.83179 2.66655 1.83199H5.00023C5.08852 1.83199 5.17323 1.79598 5.23586 1.73181C5.29849 1.66764 5.33396 1.58054 5.33453 1.4895V0.343955C5.33434 0.252791 5.29913 0.165421 5.23661 0.100958C5.1741 0.0364958 5.08936 0.000193759 5.00094 0H2.66655C1.95927 0.000194471 1.28103 0.290033 0.780972 0.805771C0.280917 1.32151 -2.51477e-08 2.02091 0 2.75018L0 8.25055C0.00018855 8.97969 0.281189 9.67892 0.781223 10.1945C1.28126 10.7101 1.9594 10.9998 2.66655 11H5.00023C5.08889 11 5.17392 10.9637 5.23661 10.899C5.29931 10.8344 5.33453 10.7467 5.33453 10.6553Z"
                      fill="#707C82"
                    />
                  </svg>
                  Log out
                </Dropdown.Item>

                <div className="dropdown-menu-version-box">{`SmartCoil Dashboard v${appVersion}`}</div>
              </Dropdown.Menu>
            )}
          </Dropdown>
        </div>
      </div>
      <CustomLoader
        idLoading={isLoading}
        handleLoading={() => setLoading(!isLoading)}
      />
    </div>
  );
};
export default connect(null, { setLogout })(CustomHeader);
